import { useCallback } from 'react';

export default (handleValueChange, handleBlur, values) =>
  useCallback(
    fieldKey => ({
      value: values[fieldKey] || '',
      onChange: ({ target: { value } }) => handleValueChange(fieldKey, value),
      onBlur: () => handleBlur(fieldKey)
    }),
    [handleBlur, handleValueChange, values]
  );
